import Rails from "@rails/ujs"
import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['form','addButton'];
  static classes = ['errorm','hide'];
  static values = {uploadurl: String, removeimageurl: String, addimagefieldurl: String};

  addUploadField(){
    const uploadField = document.getElementById("attached_image_upload_field");
    const formData = new FormData(this.formTarget);
    const index = document.getElementById("image_index");
    formData.append("index",index.value);
    Rails.ajax({
      url: this.addimagefieldurlValue,
      type: "POST",
      dataType: 'html',
      data: formData,
      success: (response) => {
        uploadField.innerHTML = response.body.innerHTML;
      }
    });
  }

  autoUpload(event){
    const el = event.currentTarget;
    const params = event.params;
    const targetName = params.targetname;
    const index = params.index;
    if(el.value != null && el.value != ""){
      const formData = new FormData(this.formTarget);
      formData.append("type",targetName);
      formData.append("index",index);
      Rails.ajax({
        url: this.uploadurlValue,
        type: "POST",
        dataType: 'json',
        data: formData,
        success: (response) => {
          if(response.error != null){
            document.getElementById("attached_image_"+targetName+"_error_message").textContent = response.error;
          }else {
            const viewDiv = document.getElementById("image_view_" + targetName);
            const image = viewDiv.querySelector("img");
            const fileInfo = viewDiv.querySelector(".attached-file-info");
            const fileName = viewDiv.querySelector(".attached-file-name");
            const fileLink = viewDiv.querySelector(".attached-file-link");
            if(response.image_file){
              image.src = response.image_url;
              image.classList.remove(this.hideClass);
              fileInfo.classList.add(this.hideClass);
            }else {
              image.src = "";
              image.classList.add(this.hideClass);
              fileName.textContent = response.file_name;
              fileLink.href = response.file_url;
              fileInfo.classList.remove(this.hideClass);
            }
            viewDiv.classList.remove(this.hideClass);
            document.getElementById("image_upload_" + targetName).classList.add(this.hideClass);
            document.getElementById("attached_image_id_" + index).value = response.ai_id;
            document.getElementById("attached_image_" + targetName + "_error_message").textContent = "";
          }
        }
      });
    }
  }

  removeImage(event){
    const params = event.params;
    const targetName = params.targetname;
    const formData = new FormData(this.formTarget);
    const index = params.index;
    formData.append("type",targetName);
    formData.append("index",index);
    Rails.ajax({
      url: this.removeimageurlValue,
      type: "POST",
      dataType: 'json',
      data: formData,
      success: (response) => {
        console.log(response);
        const viewDiv = document.getElementById("image_view_"+targetName);
        const image = viewDiv.querySelector("img");
        const fileInfo = viewDiv.querySelector(".attached-file-info");
        const fileName = viewDiv.querySelector(".attached-file-name");
        const fileLink = viewDiv.querySelector(".attached-file-link");
        image.src = "";
        image.classList.remove(this.hideClass);
        fileInfo.classList.add(this.hideClass);
        fileName.textContent = "";
        fileLink.href = "#";
        viewDiv.classList.add(this.hideClass);
        document.getElementById("attached_image_id_"+index).value = null;
        document.getElementById("image_upload_"+targetName).classList.remove(this.hideClass);
      }
    });
  }

}
